export default __webpack_public_path__ + "static/media/414.6185c4f9.gif";